import * as Html from "../util/Html.ts";
import * as FwDatas from "../FwDatas.ts";
import ApiServer from "../ApiServer.js";
import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import TPL from "../modal/reminder-custom.mustache";

export {init}
Html.registerWidget('widget/reminder-select',{init:init})

const 
  defaultOptionsAllDay = ["MINUTE-0","","HOUR-15","DAY-1","DAY-2"],
  defaultOptions = ["MINUTE-0","","MINUTE-5","MINUTE-15","MINUTE-30","HOUR-1","HOUR-2","DAY-1"],
  display = ApiServer.types.IReminder.html;

function init(element){
  var
    widget = element,
    form = element.get(0).form,
    allDayInput = $(form.allDay),
    value = widget.attr('data-value'),
    type = widget.attr('data-type');
  
  function backDataToForm(newValue){
    value = newValue;
    if(type==='task'){
      if(value){
        form['reminder.reminderType'].value = 'SNOOZE';
        form['reminder.reminderUnit'].value = value.split('-')[0];
        form['reminder.reminderValue'].value = value.split('-')[1];
      }else{
        form['reminder.reminderType'].value = 'NONE';
        form['reminder.reminderUnit'].value = 'HOUR';
        form['reminder.reminderValue'].value = 0;
      }
    }else if(type==='settings'){
      //settings case handle elsewhere
    }else if(type==='event'){
      let 
        widgets = $('select[data-widget="widget/reminder-select"]').toArray().filter(function(item){
          return $(item).val()!==null && $(item).val()!=='';
        }),
        reminders = widgets.map(item=>{
          let splitted = $(item).val().split('-');
          return {reminderType:"SNOOZE",reminderUnit:splitted[0],reminderValue:splitted[1]}
        });
      
      form.reminderList.value = JSON.stringify(reminders);
    }
  }
  
  function initOptions(forceValue){
    var 
      allDay = allDayInput.get(0) && allDayInput.get(0).checked,
      options;
    if(forceValue!==undefined){
      value = forceValue
    }

    if(allDay){
      options = [].concat(defaultOptionsAllDay)
    }else{
      options = [].concat(defaultOptions)
    }
    
    if(value && options.indexOf(value)===-1){
      options.push(value)
    }
    
    widget.html(options.map(str=>{
      let 
        splitted = str.split('-'),
        unit = str.length>1?splitted[0]:null,
        intValue = str.length>1?parseInt(splitted[1]):undefined;
      return `<option value="${str}" ${str==value?"selected":""}>${display(unit,intValue,type,allDay)}</option>`;
    }).concat([`<option value="CUSTOM">${i18n.get('recurrency.custom')}</option>`]).join(''));
    
  }
  
  function update(){
    initOptions();
    backDataToForm(widget.val());
    if(type==='event' && value!==''){
      widget.next().show();
    }
  }
  
  update();
  allDayInput.on("change",function update(){
    var 
      isFirstReminder = element.attr("data-first")==='true',
      forceValue = undefined;
    
    if(isFirstReminder){
      var 
        allDay = allDayInput.get(0).checked,
        settings = FwDatas.getSettingsPerFamily();
      forceValue = (settings.defaultReminderType==='NONE'?"":(allDay?"MINUTE-0":settings.defaultReminderUnit+"-"+settings.defaultReminderValue)) ;
    }  
    
    initOptions(forceValue);
    backDataToForm(widget.val());
    if(type==='event' && value!==''){
      widget.next().show();
    }
  });







  widget.on('change',function(event){
    if( widget.val()==='CUSTOM'){
      let theModal = modal.openModal(TPL,{});
      theModal.find('[data-button="ok"]').on('click',function(evt){
        evt.preventDefault();
        value = theModal.find('[name="unit"]').val()+'-'+theModal.find('[name="value"]').val();
        initOptions();
        backDataToForm();
        modal.closeModal(theModal);
      })
      
    }else{
      backDataToForm(widget.val());
      if(type==='event' && value!==''){
        widget.next().show();
      }
    }
    
  });
  
  
}